import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { AcknowledgementV2Dto } from '@inosio/payments-sdk';

type AcknowledgementState = {
  acknowledgements: AcknowledgementV2Dto[];
  isFetchingAcknowledgements: boolean;
  isFetchingAcknowledgementsSuccess: boolean;
  isFetchingAcknowledgementsFailed: boolean;
  isExportingAckForm: boolean;
  isExportingAckFormSuccess: boolean;
  isExportingAckFormFailed: boolean;
  exportApplicationDetailError: string;
  errorMessage: string;
  isMarkingAcknowledgmentAsResolved: boolean;
  isMarkingAcknowledgmentAsResolvedSuccess: boolean;
  isMarkingAcknowledgmentAsResolvedFailure: boolean;
  errorMarkingAcknowledgmentAsResolved: string;
};
const getInitialState = () => {
  return {
    acknowledgements: [],
    isFetchingAcknowledgements: true,
    isFetchingAcknowledgementsSuccess: false,
    isFetchingAcknowledgementsFailed: false,
    isExportingAckForm: false,
    isExportingAckFormSuccess: false,
    isExportingAckFormFailed: false,
    exportApplicationDetailError: '',
    errorMessage: '',
    isMarkingAcknowledgmentAsResolved: false,
    isMarkingAcknowledgmentAsResolvedSuccess: false,
    isMarkingAcknowledgmentAsResolvedFailure: false,
    errorMarkingAcknowledgmentAsResolved: '',
  } as AcknowledgementState;
};

const acknowledgementsSlice = createSlice({
  name: 'acknowledgementsReducer',
  initialState: getInitialState(),
  reducers: {
    getAcknowledgements(state) {
      state.isFetchingAcknowledgements = true;
      state.isFetchingAcknowledgementsSuccess = false;
      state.isFetchingAcknowledgementsFailed = false;
    },
    setAcknowledgements(state, action) {
      state.isFetchingAcknowledgements = false;
      state.isFetchingAcknowledgementsSuccess = true;
      state.isFetchingAcknowledgementsFailed = false;
      state.acknowledgements = action.payload;
    },
    setAcknowledgementsError(state, action) {
      state.isFetchingAcknowledgements = false;
      state.isFetchingAcknowledgementsSuccess = false;
      state.isFetchingAcknowledgementsFailed = true;
      state.errorMessage = action.payload.message;
    },
    getExportAckForm(state) {
      state.isExportingAckForm = true;
      state.isExportingAckFormSuccess = false;
      state.isExportingAckFormFailed = false;
      state.exportApplicationDetailError = '';
    },
    setExportAckForm(state) {
      state.isExportingAckForm = false;
      state.isExportingAckFormSuccess = true;
      state.isExportingAckFormFailed = false;
      state.exportApplicationDetailError = '';
    },
    setExportAckFormError(state, action) {
      state.isExportingAckForm = false;
      state.isExportingAckFormSuccess = false;
      state.isExportingAckFormFailed = true;
      state.exportApplicationDetailError = action.payload.message;
    },
    markAcknowledgementAsResolved(state, action) {
      state.isMarkingAcknowledgmentAsResolved = true;
      state.isMarkingAcknowledgmentAsResolvedFailure = false;
      state.isMarkingAcknowledgmentAsResolvedSuccess = false;
      state.errorMarkingAcknowledgmentAsResolved = '';
    },
    setMarkAcknowledgementResolved(state, action) {
      state.isMarkingAcknowledgmentAsResolved = false;
      state.isMarkingAcknowledgmentAsResolvedFailure = false;
      state.isMarkingAcknowledgmentAsResolvedSuccess = true;
    },
    setMarkAcknowledgementError(state, action) {
      state.isMarkingAcknowledgmentAsResolved = false;
      state.isMarkingAcknowledgmentAsResolvedFailure = true;
      state.isMarkingAcknowledgmentAsResolvedSuccess = false;
      state.errorMarkingAcknowledgmentAsResolved = action.payload;
    },
    resetAcknowledgmentResolvedStates(state) {
      state.isMarkingAcknowledgmentAsResolved = false;
      state.isMarkingAcknowledgmentAsResolvedFailure = false;
      state.isMarkingAcknowledgmentAsResolvedSuccess = false;
      state.errorMarkingAcknowledgmentAsResolved = '';
    },
  },
});

export const {
  getAcknowledgements,
  setAcknowledgements,
  setAcknowledgementsError,
  getExportAckForm,
  setExportAckForm,
  setExportAckFormError,
  markAcknowledgementAsResolved,
  setMarkAcknowledgementResolved,
  setMarkAcknowledgementError,
  resetAcknowledgmentResolvedStates,
} = acknowledgementsSlice.actions;

export default acknowledgementsSlice.reducer;
export const selectAcknowledgementsState = (state: RootState) => state.acknowledgementsState;
